module.exports = __webpack_public_path__ + "static/media/archa.113d0b61.jpg";